<template>
    <div class="row scrollable edit-event bg-white">
        <loading name="load event detail" class="col">
            <div class="col text-center">
                <h3 class="mt-3">{{$t('pages.admin.EditEvent')}}</h3>
                <hr/>
                <div class="alert alert-danger" v-if="error">{{$t(error)}}</div>
                <formly-form :form="form" :model="model" :fields="fields" ref="edit"/>
                <div class="row">
                    <div class="form-group col-6">
                        <label>{{$t('fields.BusTimeIn')}}</label>
                        <div class="input-group mb-3">
                            <input type="time" class="form-control" aria-label="add time" aria-describedby="button-add"
                                   v-model="timeIn">
                            <div class="input-group-append">
                                <button class="btn btn-primary" type="button" id="button-add"
                                        @click="addTimeIn">
                                    {{$t('button.Add')}}
                                </button>
                            </div>
                        </div>
                    </div>
                    <div class="form-group col-6">
                        <label>{{$t('fields.BusTimeOut')}}</label>
                        <div class="input-group">
                            <input type="time" class="form-control" aria-label="add time" aria-describedby="button-add"
                                   v-model="timeOut">
                            <div class="input-group-append">
                                <button class="btn btn-primary" type="button" id="button-add-out"
                                        @click="addTimeOut">
                                    {{$t('button.Add')}}
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="row">
                    <ul class="list-group col-6 pl-3">
                        <li v-for="(time, index) in model.transportTimesIn"
                            class="list-group-item d-flex justify-content-between align-items-center" :key="time">
                            {{time}}
                            <button type="button" class="close" aria-label="Close"
                                    @click="(e) => deleteTime(e, index, 'in')">
                                <i aria-hidden="true" class="fa fa-times"></i>
                            </button>
                        </li>
                    </ul>
                    <ul class="list-group col-6 pl-3">
                        <li v-for="(time, index) in model.transportTimesOut"
                            class="list-group-item d-flex justify-content-between align-items-center" :key="time">
                            {{time}}
                            <button type="button" class="close" aria-label="Close"
                                    @click="(e) => deleteTime(e, index, 'out')">
                                <i aria-hidden="true" class="fa fa-times"></i>
                            </button>
                        </li>
                    </ul>
                </div>
                <div class="text-right">
                    <button class="btn btn-primary" @click="submit">{{ $t('button.Save') }}</button>
                </div>
            </div>
        </loading>
    </div>
</template>

<script>
  import { mapActions, mapGetters } from 'vuex';
  import isLength from 'validator/lib/isLength';
  import dayjs from 'dayjs';
  import { ROUTER_NAMES } from '../../constants';

  export default {
    name: 'EditEvent',
    data() {
      const volunteerTypes = this.$store.state.admin.volunteerTypes;
      const volunteerTypeOptions = volunteerTypes ? volunteerTypes.map((type) => {
        return {
          label: type.name,
          value: type.id
        };
      }) : [];

      return {
        disabled: false,
        error: '',
        form: {},
        timeOut: '',
        timeIn: '',
        model: {
          name: '',
          theme: '',
          startRegistration: '',
          startDate: '',
          endDate: '',
          transportTimesIn: [],
          transportTimesOut: [],
          volunteerTypes: '',
        },
        fields: [
          {
            key: 'name',
            type: 'input',
            templateOptions: {
              label: this.$t('fields.Name')
            },
            required: true,
            validators: {
              validName: {
                expression(field, model, next) {
                  next(isLength(model[field.key], { min: 3 }));
                },
                message: this.$tc('validation.min', 3)
              }
            }
          },
          {
            key: 'theme',
            type: 'input',
            templateOptions: {
              label: this.$t('fields.Theme')
            },
            validators: {
              validTheme: {
                expression(field, model, next) {
                  next(!model[field.key] || isLength(model[field.key], { min: 3 }));
                },
                message: this.$tc('validation.min', 3)
              }
            }
          },
          {
            key: 'volunteerTypes',
            type: 'multi-select',
            options: volunteerTypeOptions,
            templateOptions: {
              label: this.$t('fields.VolunteerTypes'),
              multiple: true,
              closeOnSelect: false
            },
            required: true,
          },
          {
            key: 'startDate',
            type: 'date',
            templateOptions: {
              label: this.$t('fields.StartDate'),
              placeholder: this.$t('fields.StartDate')
            },
            required: true
          },
          {
            key: 'endDate',
            type: 'date',
            templateOptions: {
              label: this.$t('fields.EndDate'),
              placeholder: this.$t('fields.EndDate')
            },
            required: true
          },
          {
            key: 'startRegistration',
            type: 'date',
            templateOptions: {
              label: this.$t('fields.StartRegistrationDate'),
              placeholder: this.$t('fields.StartRegistrationDate')
            },
            required: true
          },
          {
            key: 'endRegistration',
            type: 'date',
            templateOptions: {
              label: this.$t('fields.EndRegistrationDate'),
              placeholder: this.$t('fields.EndRegistrationDate')
            },
            required: true
          },
          {
            key: 'endVolunteerRegistration',
            type: 'date',
            templateOptions: {
              label: this.$t('fields.EndVolunteerRegistrationDate'),
              placeholder: this.$t('fields.EndVolunteerRegistrationDate')
            },
            required: true,
          }
        ]
      };
    },
    created() {
      this.$wait.start('load event detail');
      const detail = this.detailEvent({
        eventId: this.eventId
      });
      const volunteerTypes = this.loadVolunteerTypes();

      Promise.all([detail, volunteerTypes])
        .then(() => {
          if (this.event) {
            const volunteerTypes = this.event.volunteerTypes.map((type) => {
              return {
                label: type.name,
                value: type.id
              };
            });

            this.model = {
              name: this.event.name,
              theme: this.event.theme,
              startRegistration: this.event.start_registration,
              startDate: this.event.start_date,
              endDate: this.event.end_date,
              endRegistration: this.event.end_registration,
              endVolunteerRegistration: this.event.end_volunteer_registration,
              transportTimesIn: this.event.busInTimes.map((time) => time.time),
              transportTimesOut: this.event.busOutTimes.map((time) => time.time),
              volunteerTypes: volunteerTypes
            };
          }
          this.$wait.end('load event detail');
        });
    },
    methods: {
      ...mapActions(['editEvent', 'loadVolunteerTypes', 'detailEvent']),
      getTransportTimesArray(type) {
        if (type === 'in') {
          return this.model.transportTimesIn;
        }

        return this.model.transportTimesOut;
      },
      addTimeIn(e) {
        e.preventDefault();

        this.model.transportTimesIn.push(this.timeIn);
        this.timeIn = '';
      },
      addTimeOut(e) {
        e.preventDefault();

        this.model.transportTimesOut.push(this.timeOut);
        this.timeOut = '';
      },
      deleteTime(e, index, type) {
        e.preventDefault();

        this.getTransportTimesArray(type)
          .splice(index, 1);
      },
      submit(e) {
        e.preventDefault();

        this.$refs.edit.validate()
          .then(() => {
            if (!this.form.$valid) return;
            var data = {
              ...this.model,
              eventId: this.eventId
            };

            data.volunteerTypes = data.volunteerTypes.map((item) => item.value);

            data.startDate = dayjs(data.startDate)
              .format('YYYY-MM-DD');
            data.startRegistration = dayjs(data.startRegistration)
              .format('YYYY-MM-DD');
            data.endDate = dayjs(data.endDate)
              .format('YYYY-MM-DD');
            data.endVolunteerRegistration = dayjs(data.endVolunteerRegistration)
              .format('YYYY-MM-DD');
            data.endRegistration = dayjs(data.endRegistration)
              .format('YYYY-MM-DD');


            this.disabled = true;
            this.editEvent(data)
              .then(response => {
                this.$router.push({
                  name: ROUTER_NAMES.ADMIN_EVENTS
                });
                this.disabled = false;
              })
              .catch(() => {
                this.disabled = false;
                this.$router.push({
                  name: ROUTER_NAMES.ERROR
                });
              });
          });
      }
    },
    computed: {
      ...mapGetters(['getVolunteerTypes']),
      event() {
        return this.$store.state.admin.eventDetail[this.eventId];
      },
      eventId() {
        return this.$route.params.eventId;
      }
    },
  };
</script>

<style scoped>

</style>
